import { render, staticRenderFns } from "./quotation1.vue?vue&type=template&id=eb223bfa&scoped=true&"
import script from "./quotation1.vue?vue&type=script&lang=js&"
export * from "./quotation1.vue?vue&type=script&lang=js&"
import style0 from "./quotation1.vue?vue&type=style&index=0&id=eb223bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb223bfa",
  null
  
)

export default component.exports